import React, { FC } from 'react'
import { PrimaryButton } from '@moonpig/launchpad-components'
import { breakpointDown, styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { useProductContext } from '../../../contexts/product'
import { useFindLocaleText } from '../../../text-localisation'
import { ProductWithRecommendations } from '../../../components/ProductDetails'
import { ProductModuleSection } from '../ProductModuleSection'
import { ProductModule } from '../types'
import { useModularAddToBasket } from './useModularAddToBasket'

const CTA_CONTAINER_MIN_HEIGHT = {
  desktop: '52px',
  mobile: '85px',
}

const StyledCtaContainer = styled.div`
  width: 100%;
  min-height: ${CTA_CONTAINER_MIN_HEIGHT.desktop};
  ${s({
    borderTop: { xs: 1, md: 0 },
    borderColor: { xs: 'colorBorder04', md: 'none' },
    boxShadow: { xs: 4, md: 0 },
    mb: { xs: 0, md: 0 },
  })}
  ${breakpointDown('md')} {
    bottom: 0;
    left: 0;
    position: fixed;
    background-color: white;
    z-index: 3;
    min-height: ${CTA_CONTAINER_MIN_HEIGHT.mobile};
    ${s({
      p: 6,
    })}
    justify-content: center;
  }
`

const getButtonText = ({
  canSeeCardOptions,
  product: { customisable },
}: {
  product: ProductWithRecommendations
  canSeeCardOptions: boolean
}) => {
  const digitalGiftButtonText = 'find.add_gift_to_a_card'

  if (canSeeCardOptions) {
    return digitalGiftButtonText
  }

  return customisable ? 'common.personalise' : 'common.add_to_basket'
}

export const AddToBasketCTAModule: FC<ProductModule> = props => {
  const [{ product }] = useProductContext()
  const localiseText = useFindLocaleText()

  const { addProductToBasket, canSeeCardOptions } = useModularAddToBasket()

  const buttonText = localiseText(getButtonText({ product, canSeeCardOptions }))

  return (
    <ProductModuleSection {...props}>
      <StyledCtaContainer>
        <PrimaryButton
          width={1}
          onClick={addProductToBasket}
          className="add-to-basket-cta"
        >
          {buttonText}
        </PrimaryButton>
      </StyledCtaContainer>
    </ProductModuleSection>
  )
}
